import React, { useState } from 'react'
import './IdVerification.css'
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import NoImgPlaceholder from "../../../assets/images/no-image.png"
import NoDocImagePlaceholder from "../../../assets/images/no-doc-img-placeholder.png"
import { Button, Chip } from '@mui/material';
import SecDocVerificationDiolog from '../verificationDialog/SecDocVerificationDialog';
import FaceMatchVerificationDialog from '../verificationDialog/FaceMatchVerificationDialog';
import IdVerificationDialog from '../verificationDialog/IdVerificationDialog'
import ZoomDialog from '../verificationDialog/ZoomDialog';

const isValidStringData = (str) => {
    if (!str) return false;
    const invalidTypes = ['N/A', 'NA', 'null', '', undefined, null];
    return !invalidTypes.includes(str.trim());
}

const VerificationComponentHeader = ({ title, documentType, handleZoomButton, showChip = true }) => {
    return (
        <div className="card-header">
            <div className='title-wrap'>
                <h2>{title}</h2>
                {showChip && (isValidStringData(documentType) ? (
                    <span className='sub-title'>
                        <Chip
                            size='small' label={documentType}
                            sx={{
                                backgroundColor: '#D4ECEF',
                                padding: '4px',
                                borderRadius: '4px'
                            }} />
                    </span>
                ) : (
                    <span className='sub-title'>
                        <Chip size='small' label="Unrecognized"
                            sx={{
                                backgroundColor: '#D4ECEF',
                                padding: '4px',
                                borderRadius: '4px'
                            }} />
                    </span>
                ))}
            </div>
            <Button
                variant="contained"
                className="magnify-button"
                onClick={handleZoomButton}
                sx={{
                    minWidth: "auto",
                    padding: "8px",
                    boxShadow: 'none',
                    backgroundColor: 'transparent',
                    color: "black",
                    '&:hover': {
                        boxShadow: 'none',
                        backgroundColor: '#E9F2F4'
                    }
                }}>
                <ZoomInIcon />
            </Button>
        </div>
    )
}

const IdVerification = ({
    selfie,
    documentPortrait,
    sorPortrait,
    primaryFrontImage,
    primaryBackImage,
    primaryDocument,
    secondaryDocument,
    secondaryFrontImage }) => {

    const [showFaceZoomDialog, setShowFaceZoomDialog] = useState(false);
    const [showSecDocZoomDialog, setShowSecDocZoomDialog] = useState(false);
    const [showDocumentZoomDialog, setShowDocumentZoomDialog] = useState(false)

    const singleImage = [secondaryFrontImage?.imageData];

    const doubleImages = [
        primaryFrontImage?.imageData,
        primaryBackImage?.imageData
    ].filter(Boolean);

    const tripleImages = [
        selfie?.imageData,
        documentPortrait?.imageData,
        sorPortrait
    ].filter(Boolean);

    return (
        <div className="verification-container full-width">
            <div className="verification-card face-match-card review-component-container">
                <VerificationComponentHeader
                    showChip={false}
                    title="Face Match"
                    handleZoomButton={() => setShowFaceZoomDialog(prev => !prev)} />

                <div className="face-match-content">
                    <div className="image-comparison">
                        {/* TODO: Refacter the code to use single JSX for showing three image containers */}
                        <div className="image-container">
                            <p className="image-label">Selfie</p>
                            <div className="image-placeholder">
                                {isValidStringData(selfie?.imageData) ?
                                    <img
                                        src={`data:image/jpeg;base64,${selfie?.imageData}`}
                                        alt="Selfie"
                                        className="image"
                                    />
                                    :
                                    <img
                                        src={NoImgPlaceholder}
                                        alt="Selfie"
                                        className="image" />
                                }
                            </div>
                        </div>
                        <div className="image-container">
                            <p className="image-label">Document Portrait</p>
                            <div className="image-placeholder">
                                {isValidStringData(documentPortrait?.imageData) ?
                                    <img
                                        src={`data:image/jpeg;base64,${documentPortrait?.imageData}`}
                                        alt="Document Portrait"
                                        className="image"
                                    />
                                    :
                                    <img
                                        src={NoImgPlaceholder}
                                        alt="Document Portrait"
                                        className="image" />
                                }
                            </div>
                        </div>
                        <div className="image-container">
                            <p className="image-label">SoR</p>
                            <div className="image-placeholder">
                                {isValidStringData(sorPortrait) ?
                                    <img
                                        src={`data:image/jpeg;base64,${sorPortrait}`}
                                        alt="SOR Document Portrait"
                                        className="image" />
                                    :
                                    <img
                                        src={NoImgPlaceholder}
                                        alt="SOR Document Portrait"
                                        className="image" />
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="verification-card document-verify-card review-component-container">
                <VerificationComponentHeader
                    title="Primary Document"
                    documentType={primaryDocument?.ocrDocumentType}
                    handleZoomButton={() => setShowDocumentZoomDialog(prev => !prev)} />
                <div className="document-verification-content">
                    <div className="document-sides">
                        <div className="document-side">
                            <div className="document-placeholder">
                                {isValidStringData(primaryFrontImage?.imageData) ? (
                                    <img
                                        className="document-img"
                                        src={`data:image/jpeg;base64,${primaryFrontImage?.imageData}`}
                                        alt={"Front Preview"}
                                    />
                                ) : (
                                    <img
                                        className="document-img"
                                        src={NoDocImagePlaceholder}
                                        alt="Not available"
                                    />
                                )}
                            </div>
                            <p className="document-label">Front</p>
                        </div>
                        <div className="document-side">
                            <div className="document-placeholder">
                                {isValidStringData(primaryBackImage?.imageData) ? (
                                    <img
                                        className="document-img"
                                        src={`data:image/jpeg;base64,${primaryBackImage?.imageData}`}
                                        alt={"Back Preview"}
                                    />
                                ) : (
                                    <img
                                        className="document-img"
                                        src={NoDocImagePlaceholder}
                                        alt="Not available"
                                    />
                                )}
                            </div>
                            <p className="document-label">Back</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className='verification-card secondary-document-card'>
                <VerificationComponentHeader
                    title="Secondary Document"
                    documentType={secondaryDocument?.documentType}
                    handleZoomButton={() => setShowSecDocZoomDialog(prev => !prev)} />

                <div className='secondary-document-content'>
                    <div className="document-side">
                        <div className="document-placeholder">
                            {isValidStringData(secondaryFrontImage?.imageData) ? (
                                <img
                                    className="document-img"
                                    src={`data:image/jpeg;base64,${secondaryFrontImage?.imageData}`}
                                    alt="Secondary document front"
                                />
                            ) : (
                                <img
                                    className="document-img"
                                    src={NoDocImagePlaceholder}
                                    alt="Not available"
                                />
                            )}
                        </div>
                        <p className="document-label">Front</p>
                    </div>
                </div>
            </div>

            {/* <FaceMatchVerificationDialog
                isOpen={showFaceZoomDialog}
                onClose={() => setShowFaceZoomDialog(prev => !prev)}
                selfieImageData={selfie?.imageData}
                documentPortraitImageData={documentPortrait?.imageData}
                sorPortraitImageData={sorPortrait} />

            <SecDocVerificationDiolog
                isOpen={showSecDocZoomDialog}
                onClose={() => setShowSecDocZoomDialog(prev => !prev)}
                secDocImageData={secondaryFrontImage?.imageData} />

            <IdVerificationDialog
                isOpen={showDocumentZoomDialog}
                onClose={() => setShowDocumentZoomDialog(prev => !prev)}
                primaryDocumentFrontImageData={primaryFrontImage?.imageData}
                primaryDocumentBackImageData={primaryBackImage?.imageData}
            /> */}

            <ZoomDialog
                isOpen={showFaceZoomDialog}
                onClose={() => setShowFaceZoomDialog(prev => !prev)}
                title="Face Match"
                dialogType="faceMatch"
                images={tripleImages}
            />

            <ZoomDialog
                isOpen={showDocumentZoomDialog}
                onClose={() => setShowDocumentZoomDialog(prev => !prev)}
                title="Primary Document"
                dialogType="primaryDocument"
                images={doubleImages}
            />

            <ZoomDialog
                isOpen={showSecDocZoomDialog}
                onClose={() => setShowSecDocZoomDialog(prev => !prev)}
                title="Secondary Document"
                dialogType="secondaryDocument"
                images={singleImage}
            />
        </div>
    )
}

export default IdVerification